'use client'

import { Avatar as AvatarOrigin, Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/system'

type Props = {
  alt?: string
  src: string
  size: number
  sx?: SxProps<Theme>
}

export const Avatar = ({ alt, src, size, sx }: Props) => {
  return (
    <Box sx={{ position: 'relative', width: size, height: size, ...sx }}>
      <AvatarOrigin alt={alt} src={src} sx={{ width: size, height: size }} />
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '50%',
        }}
      />
    </Box>
  )
}
